import React, { ReactElement } from 'react';
import './Rules.scss';

const Et: React.FC = (): ReactElement => {
  return (
    <div className="Et rules-wrapper">
      <h2>Kampaania reeglid</h2>
      <ol>
        <li>
          Fazeri kampaania on{' '}
          <span className="bold">alates 01.08.2026 kuni 31.08.2026</span> toimuv
          tarbijamäng (edaspidi kampaania), mis leiab aset{' '}
          <span className="bold">
            kõigis Eesti Vabariigi territooriumil asuvates kauplustes
          </span>
          , kus kampaanias osalevaid tooteid müüakse.
        </li>
        <li>
          Kampaania ja auhinnad korraldab:{' '}
          <span className="bold">Fazer Eesti OÜ</span> (Reg. nr 10057691), Pärnu
          maantee 158/1, 11317 Tallinn, Kawe Ärikeskuse 5. korrus; telefon: +372
          650 2421; e-post:{' '}
          <a href="mailto:info@fazer.ee">info@fazer.ee</a>{' '}
        </li>

        <h3>OSALEMINE ja AUHINNAD</h3>

        <li>
          Kampaania info on kättesaadav aadressil{' '}
          <a href="http://www.fazer.ee">www.fazer.ee</a>
        </li>
        <li>
          Kampaania auhinna loosimises osalemiseks tuleb osta{' '}
          <span className="bold">ükskõik millisest kauplusest üle-Eesti </span>{' '}
          vähemalt üks kampaanias osalev{' '}
          <span className="bold">Fazer röstsai</span> ja registreerida{' '}
          <span className="bold">ostutšeki number</span> veebilehel{' '}
          <a href="https://www.fazer.ee/">https://www.fazer.ee/</a> ajavahemikus{' '}
          <span className="bold">01.08.26 – 31.08.2026 </span>(k.a).
        </li>
        <li>
          Auhinnafondi <span className="bold">koguväärtus on 1539 €</span>{' '}
          (sisaldab käibemaksu).
          <span className="block-span">Auhinnafondis on kokku 1 auhind:</span>
          <ul>
            <li>1x iPhone 17 Pro Max 256 GB</li>
          </ul>
        </li>
        <li>
          Kampaanias osaleja peab registreeritud ostutšeki alles hoidma
          kampaania lõpuni, et esitada see võimaliku võidu kättesaamiseks.
        </li>
        <li>Ühte ostutšekki saab kampaania jooksul registreerida ühe korra.</li>
        <li>
          Osaleja võib teha mitu registreerimist, kui ostab kampaanias osalevaid
          tooteid mitu korda ja registreerib{' '}
          <span className="bold">iga kord uue ostutšeki numbri.</span>
        </li>
        <li>Kampaanias osalevad tooted on:</li>
        <table>
          <thead>
            <tr>
              <td>EAN</td>
              <td>Toote nimetus</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>4740103011256</td>
              <td>Fazeri Juuretise Röst 450g</td>
            </tr>
            <tr>
              <td>4740103011188</td>
              <td>Fazer Seemneröst 500g</td>
            </tr>
            <tr>
              <td>4740103011300</td>
              <td>Fazer Seemnetega röst 500g</td>
            </tr>
            <tr>
              <td>4740103012413</td>
              <td>Fazer 5-vilja röstsepik 480g</td>
            </tr>
            <tr>
              <td>4740103011164</td>
              <td>Fazer Keefiriröst kaltsiumiga 450g</td>
            </tr>
            <tr>
              <td>4740103011096</td>
              <td>Fazer Kamaröst 400g</td>
            </tr>
            <tr>
              <td>4740103011720</td>
              <td>Fazer Täistera röstsepik 250g</td>
            </tr>
            <tr>
              <td>4740103010549</td>
              <td>Fazer Kodusai röst 500g</td>
            </tr>
            <tr>
              <td>4740103010204</td>
              <td>Fazer Kodusai mini röst 240g</td>
            </tr>
          </tbody>
        </table>
        <li>
          Loosimised viiakse läbi loosimistarkvara stat.messenger.ee abil, mis
          võimaldab määrata loosimise täpse perioodi, auhindade kogused ning
          valib võitjad määratud perioodi jooksul registreerunud osalejate seast
          juhuse alusel. Auhinna loosimine toimub 02.09.2026 (osalevad kõik
          registreeringud, mis on tehtud vahemikus 01.08.2026 kl
          00:00:00–31.08.2026 kl 23:59:59):
          <ul>
            <li>1x iPhone 17 Pro Max 256 GB</li>
          </ul>
        </li>
        <li>
          Loosimisel osalevad kõik kampaania perioodil vastavalt kampaania
          tingimustele üle-Eesti kauplustes sooritatud ostude registreeritud
          ostutšekid.
        </li>
        <li>
          Võitjaga võetakse korraldaja esindaja poolt ühendust
          registreerimisvormis märgitud e-posti või telefoni teel võidu
          kinnitamiseks ning auhinna kättetoimetamise täpsustamiseks. Võitja
          nimi avaldatakse veebilehel{' '}
          <a href="http://www.fazer.ee">www.fazer.ee</a> hiljemalt 3 tööpäeva
          jooksul pärast loosimise kuupäeva.
        </li>
        <li>
          Juhul, kui võitjaga ei ole õnnestunud ühendust saada hiljemalt 5
          tööpäeva jooksul on korraldajal õigus auhinda mitte väljastada ja
          loosida see välja uuele võitjale.
        </li>
        <h3>MUUD TINGIMUSED</h3>
        <li>
          Võidetud auhinna kättesaamisega seotud kulutusi ei kompenseerita,
          saadud auhinda ei asendata teise auhinnaga ega hüvitata selle
          maksumust rahas. Kampaania korraldaja võtab vastutuse kõigi
          auhindadega seotud seadusjärgsete maksude tasumise eest.
        </li>
        <li>
          Auhinna kättesaamiseks peab võitja esitama oma isikut tõendava
          dokumendi ning võidu toonud ostutšeki.
        </li>
        <li>
          Kampaanias ei saa osaleda selle korraldamisega seotud inimesed ja
          nende pereliikmed.
        </li>
        <li>
          Kampaania korraldaja ei kanna vastutust selle eest, kui auhinda
          eeskirjade mittejärgimise tõttu välja ei anta, kui kampaanias osaleja
          esitatud andmed on väärad või ebatäpsed või kui võitjatega ei ole
          võimalik ühendust võtta kampaania korraldajatest mittesõltuvatel
          põhjustel.
        </li>
        <li>
          Kõik kampaaniast tulenevad vaidlused lahendatakse vastavalt Eesti
          Vabariigi seadustele. Vääramatu jõu (force majeure) ilmnemisel on
          korraldajal õigus tarbijamäng ühepoolselt katkestada, teatades sellest
          meedia vahendusel.
        </li>
        <li>
          Kõik pretensioonid seoses kampaania korraldamise ja/või läbiviimisega
          tuleb saata kirjalikult kampaania korraldaja asukohta:{' '}
          <span className="bold">Fazer Eesti OÜ</span> (Reg. nr 10057691), Pärnu
          maantee 158/1, 11317 Tallinn, Kawe Ärikeskuse 5.korrus; telefon: +372
          650 2421; e-post: <a href="mailto:info@fazer.ee">info@fazer.ee</a> .
          Laekunud pretensioonidele vastatakse kirjalikult 2 nädala jooksul.
        </li>
        <li>
          Lisateavet kampaania kohta saab tööpäevadel telefonil: +372 650 2421
          ja e-posti aadressil: <a href="mailto:info@fazer.ee">info@fazer.ee</a>
        </li>
        <h3>ANDMETE TÖÖTLEMINE</h3>
        <li>
          Isikuandmete vastutav töötleja on Fazer Eesti OÜ, Pärnu mnt 158/1,
          11317 Tallinn. Kampaanias osalejatel on õigus saada lisainfot Fazer
          Eesti OÜ poolt isikuandmete töötlemise kohta. Selleks tutvu lähemalt
          Fazer Eesti OÜ privaatsustingimustega siin:{' '}
          <a href="https://www.fazergroup.com/privacy/">
            https://www.fazergroup.com/privacy/
          </a>
        </li>
        <li>Võitjate nimed on veebilehel üleval kuni 25.09.2026.</li>
        <li>Kogutud andmeid säilitatakse kuni 09.10.2026.</li>
      </ol>
    </div>
  );
};

export default Et;
